import React from 'react'
import hr from "../../../images/padu/workflow.webp"
import boy from "../../../images/padu/boy.webp"
import discussion from "../../../images/padu/discuss.webp"
import teamWork from "../../../images/padu/team-work.webp"
import rating from "../../../images/padu/rating.webp"
import university from "../../../images/students/university.webp"
import schoolBoy from "../../../images/students/school-boy.webp"
import { LuBadge, LuCircleCheckBig, LuUser } from 'react-icons/lu'



export default function Workflow() {
    return (
        <div className='mb-[20px] sm:mb-[50px] xl:mb-[70px] p-[20px] relative z-0 w-full  overflow-hidden text-center'>
            <img src={hr} alt='banner' loading='lazy' className='mx-auto object-cover w-[90px] md:w-[135px]' />
            <h5 className='text-[#000000] font-semibold text-[22px] md:text-[30px]'>Real-World Workflows</h5>
            <div className='mt-[20px] md:mt-[50px] flex gap-[22px] flex-wrap justify-center items-center text-[#1E2939] text-[15px] md:text-[18px] font-semibold'>
                <div className='w-full md:w-[330px] p-[15px] md:py-[30px] border-[1px] border-[#E9EAEB] rounded-[12px] md:rounded-[18px] flex flex-col justify-center items-center'>
                    <img src={boy} alt='boy' loading='lazy' className='mx-auto w-[84px] md:w-[104px]'/>
                    <p className='mt-[10px] md:mt-[18px]'>Real projects</p>
                </div>
                <div className='w-full md:w-[330px] p-[15px] md:py-[30px] border-[1px] border-[#E9EAEB] rounded-[12px] md:rounded-[18px] flex flex-col justify-center items-center'>
                    <img src={discussion} alt='discussion' loading='lazy' className='mx-auto w-[84px] md:w-[104px]'/>
                    <p className='mt-[10px] md:mt-[18px]'>Real collaboration</p>
                </div>
                <div className='w-full md:w-[330px] p-[15px] md:py-[30px] border-[1px] border-[#E9EAEB] rounded-[12px] md:rounded-[18px] flex flex-col justify-center items-center'>
                    <img src={teamWork} alt='teamWork' loading='lazy' className='mx-auto w-[84px] md:w-[104px]'/>
                    <p className='mt-[10px] md:mt-[18px]'>Real problem-solving</p>
                </div>
                <div className='w-full md:w-[330px] p-[15px] md:py-[30px] border-[1px] border-[#E9EAEB] rounded-[12px] md:rounded-[18px] flex flex-col justify-center items-center'>
                    <img src={rating} alt='rating' loading='lazy' className='mx-auto w-[84px] md:w-[104px]'/>
                    <p className='mt-[10px] md:mt-[18px]'>Real feedback loops</p>
                </div>
            </div>
            <p className='text-[#6A7282] font-medium text-[14px] md:text-[18px] mt-[12px] md:mt-[24px]'>A simulation of modern workplaces — to build confidence, <br className='hidden md:block'/> capability & readiness.</p>
            <div className='md:w-11/12 xl:w-10/12 mx-auto mt-[50px] lg:mt-[100px] grid md:grid-cols-2 gap-[20px] md:gap-[50px]'>
                <div className='border border-[#B9F8CF] bg-gradient-to-r from-[#F0FDF4] to-[#ECFDF5] rounded-[12px] md:rounded-[28px] p-[15px] md:p-[30px] text-start'>
                    <img src={university} alt='university' className='size-[90px] md:size-[140px] object-cover' loading='lazy'/>
                    <div className='bg-[#34C75921] rounded-full w-max px-[8px] md:px-[16px] py-[4px] md:py-[8px] text-[#0D542B] text-[10px] md:text-[14px] font-bold flex gap-[5px] items-center mt-[12px] md:mt-[25px]'>
                        <LuBadge className='text-[#34C759]' />
                        <p>WHAT COLLEGES RECEIVE</p>
                    </div>
                    <div className='mt-[12px] md:mt-[25px] text-[#101828] font-medium text-[14px] md:text-[20px]'>
                        <div className='flex gap-[8px] md:gap-[16px] items-center'>
                            <LuCircleCheckBig className='text-[14px] md:text-[24px] text-[#00A63E] flex-shrink-0' />
                            <p>Surge Certified Shield and branding</p>
                        </div>
                        <div className='flex gap-[8px] md:gap-[16px] items-center mt-[18px] md:mt-[36px]'>
                            <LuCircleCheckBig className='text-[14px] md:text-[24px] text-[#00A63E] flex-shrink-0' />
                            <p>Annual SK keynote and faculty alignment guide</p>
                        </div>
                        <div className='flex gap-[8px] md:gap-[16px] items-center mt-[18px] md:mt-[36px]'>
                            <LuCircleCheckBig className='text-[14px] md:text-[24px] text-[#00A63E] flex-shrink-0' />
                            <p>Student clarity and capability reports</p>
                        </div>
                        <div className='flex gap-[8px] md:gap-[16px] items-center mt-[18px] md:mt-[36px]'>
                            <LuCircleCheckBig className='text-[14px] md:text-[24px] text-[#00A63E] flex-shrink-0' />
                            <p>Campus skilling roadmap and parent trust assets</p>
                        </div>
                    </div>
                </div>
                <div className='border border-[#A7C3FF] bg-[#EFF6FF] rounded-[12px] md:rounded-[28px] p-[15px] md:p-[30px] text-start'>
                    <img src={schoolBoy} alt='schoolBoy' className='size-[90px] md:size-[140px] object-cover' loading='lazy'/>
                    <div className='bg-[#D2E5FE] rounded-full w-max px-[8px] md:px-[16px] py-[4px] md:py-[8px] text-[#155DFC] text-[10px] md:text-[14px] font-bold flex gap-[5px] items-center mt-[12px] md:mt-[25px]'>
                        <LuUser className='text-[#155DFC]' />
                        <p>WHAT STUDENTS RECEIVE</p>
                    </div>
                    <div className='mt-[12px] md:mt-[25px] text-[#101828] font-medium text-[14px] md:text-[20px]'>
                        <div className='flex gap-[8px] md:gap-[16px] items-center'>
                            <LuCircleCheckBig className='text-[14px] md:text-[24px] text-[#155DFC] flex-shrink-0' />
                            <p>Clarity</p>
                        </div>
                        <div className='flex gap-[8px] md:gap-[16px] items-center mt-[18px] md:mt-[24px]'>
                            <LuCircleCheckBig className='text-[14px] md:text-[24px] text-[#155DFC] flex-shrink-0' />
                            <p>Confidence</p>
                        </div>
                        <div className='flex gap-[8px] md:gap-[16px] items-center mt-[18px] md:mt-[24px]'>
                            <LuCircleCheckBig className='text-[14px] md:text-[24px] text-[#155DFC] flex-shrink-0' />
                            <p>Capability</p>
                        </div>
                        <div className='flex gap-[8px] md:gap-[16px] items-center mt-[18px] md:mt-[24px]'>
                            <LuCircleCheckBig className='text-[14px] md:text-[24px] text-[#155DFC] flex-shrink-0' />
                            <p>Professional readiness</p>
                        </div>
                        <div className='flex gap-[8px] md:gap-[16px] items-center mt-[18px] md:mt-[24px]'>
                            <LuCircleCheckBig className='text-[14px] md:text-[24px] text-[#155DFC] flex-shrink-0' />
                            <p>Career direction and identity</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
